// extracted by mini-css-extract-plugin
export default {"wrapper":"Finances_wrapper__iNGkR","container":"Finances_container__w0gQ4"};